import React, {Fragment, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {
    CustomDelete,
    EditWithIcon,
    CustomDelByNote,
    CustomizedSwitch,
    SimpleTooltip,
    RemoveClaim,
    MinLoader
} from 'components';
import {FindLoad, FindSuccessItem, Images, PermissionList, RolePermission, useModal, useWidth} from 'utils';
import {claimActions, httpRequestsOnSuccessActions} from 'store';
import {claimDetailsStyle} from './styles';
import {APPEAL, CLOSED_CLAIM, OPEN, PAID, PENDING_CLAIM} from './constants';
import {EditClaim} from './core/editClaim';
import {RefreshClaim} from './core/refreshClaim';
import {clearinghouseStatusEnums} from '../../../../pages/billing/claim/constants';
import {SubmittedClaimStatus} from '../../../../pages/billing/claim/core/submittedClaimStatus';
import {ResubmitClaim} from '../../../../pages/billing/claim/core/resubmitClaim';
import {SelectSubmissionMethod} from '../../../../pages/billing/claim/core';
import {renderSecondaryBillingImage, secondaryStatusEnums} from '../../../../pages/billing/claimPayment/constants';
import {ManageSecondaryBilling} from '../../../../pages/billing/claim/core/manageSecondaryBilling';

const CLOS_CLAIM_ACTION_TYPE = 'CLOSE_CLAIM';
const DELETE_CLAIM = 'DELETE_CLAIM';
const CANCEL_CLAIM = 'CANCEL_CLAIM';
const MARK_AS_MARKED = 'MARK_AS_READY_SECONDARY_BILLING';
const CHECK_CLAIM_STATUS = 'CHECK_CLAIM_STATUS';
export const ClaimDetailHeader = ({afterSuccess, onClose}) => {
    const claimById = useSelector((state) => state.claim.claimById);
    const canUseIntegrations = useSelector((state) => state.system.canUseIntegrations);
    const classes = claimDetailsStyle();
    const location = useLocation();
    const info = location?.state;
    const dispatch = useDispatch();
    const {open, close} = useModal();
    const claimIsClosed = claimById?.status === CLOSED_CLAIM;
    const closeButnStyle = `${classes.closeButnStyle} ${claimIsClosed ? 'closed' : ''}`;
    const loadMark = FindLoad(MARK_AS_MARKED);
    const markSuccess = FindSuccessItem(MARK_AS_MARKED);
    const checkReady = claimById?.secondaryBilling?.secondaryBillingState === secondaryStatusEnums.READY;
    const width = useWidth();

    // Refresh the claim shown in the modal AND notify the parent list/page so it refetches.
    const handleActionSuccess = () => {
        if (claimById?.id) {
            dispatch(claimActions.getClaimById(claimById?.id, 'noLoad'));
        }
        afterSuccess?.();
    };

    // For actions that remove the claim from its current list (delete): refresh the parent
    // and close the claim modal, since there is nothing left to show.
    const handleRemoveSuccess = () => {
        afterSuccess?.();
        onClose?.();
    };

    // `changeSecondaryBilling` dispatches directly (no modal with its own afterSuccess). Its saga
    // already refetches the claim shown in the modal, so here we only refresh the parent list/page.
    useEffect(() => {
        if (markSuccess) {
            afterSuccess?.();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(MARK_AS_MARKED));
        }
    }, [markSuccess]);
    const changeSecondaryBilling = () => {
        const sendParams = checkReady
            ? {
                secondaryBillingState: secondaryStatusEnums.MARKED,
            }
            : {
                payerId: claimById?.secondaryBilling?.payerId ? claimById?.secondaryBilling?.payerId : claimById?.funderId,
                authId: claimById?.secondaryBilling?.authID ? claimById?.secondaryBilling?.authID : claimById?.authorizationId,
                secondaryBillingState: secondaryStatusEnums.READY,
            };
        dispatch(claimActions.markAsReadySecondaryBilling(claimById?.id, sendParams));
    };

    const handleAction = () => {
        if (claimById?.secondaryBilling?.secondaryBillingState === secondaryStatusEnums.READY && !claimById?.secondaryBilling?.submitted) {
            open(
                <ManageSecondaryBilling
                    claim={claimById}
                    afterSuccess={handleActionSuccess}
                />
            );
        } else {
            open(
                <CustomDelete
                    text={'Are you sure you want to unmark this claim?'}
                    info={'Unmark Secondary Billing'}
                    innerText={'Unmark Claim'}
                    color={'blue'}
                    handleDel={() => dispatch(claimActions.markAsSecondaryBilling(claimById?.id, {mark: false}))}
                    afterSuccess={() => {
                        close();
                        handleActionSuccess();
                    }}
                    actionType={'MARK_AS_SECONDARY_BILLING'}
                    body={
                        <div>
                            <div className="deleting-client-info-box"
                                 style={{alignItems: 'flex-start', marginBottom: 12}}>
                                <img style={{marginTop: '3px'}} src={Images.receipt} alt="icon"/>
                                <p style={{fontWeight: 400, color: '#0C66E4'}}>{claimById?.displayId}</p>
                            </div>
                        </div>
                    }
                />
            );
        }
    };

    return (
        <Fragment>
            <div className="tabs-wrapper">
                <div
                    className="space-between-flex-start"
                    style={{ marginTop: 12 }}
                >
                    <div className="flex-align-center" style={{gap: 8}}>
                        <div className="detail-page-title-box">
                            <p>Claim ID: </p>
                            <span> {claimById?.displayId}</span>
                            {/*{(claimById?.updateFlag || claimById?.incompleteUnitFlag || claimById?.removedFromClaimFlag) && claimById?.status === PENDING_CLAIM &&*/}
                            {/*    <ApptFlags id={' '} updateFlag={claimById?.updateFlag}*/}
                            {/*               incomplete={claimById?.incompleteUnitFlag}*/}
                            {/*               removed={claimById?.removedFromClaimFlag} />*/}
                            {/*}*/}
                        </div>

                        {/*{claimById?.status === OPEN && claimById?.secondaryBilling && (*/}
                        {claimById?.status === OPEN && (
                            <div className="flex-align-center" style={{gap: 8}}>
                                <button onClick={() => handleAction()} className="reset-btn-by-default">
                                    <img src={renderSecondaryBillingImage(claimById?.secondaryBilling)}
                                         alt="secondary-billed"/>
                                </button>

                                {/*<img src={*/}
                                {/*    claimById?.secondaryBilling?.secondaryBillingState === secondaryStatusEnums.SUBMITTED ?*/}
                                {/*    Images.secondarySubmitted*/}
                                {/*        :*/}
                                {/*    Images.secondaryBillingFilled*/}
                                {/*} alt="secondaryBilled" */}
                                {/*/>*/}

                                <div className="secondary-billing-box">
                                    <SimpleTooltip
                                        title={
                                            checkReady
                                                ? 'Switch to return this claim to primary billing.'
                                                : 'Switch to resubmit this claim to the secondary payer'
                                        }
                                        placement="top"
                                        arrow>
                                        <div className="flex-align-center" style={{gap: 12}}>
                                            {loadMark?.length ? (
                                                <div style={{width: '32px'}}>
                                                    <MinLoader
                                                        width={'19px'}
                                                        height={'19px'}
                                                        margin={'0'}
                                                        color={'#7F56D9'}
                                                        position={'relative'}
                                                    />
                                                </div>
                                            ) : (
                                                <CustomizedSwitch
                                                    checkedBgColor={'#7F56D9'}
                                                    checked={checkReady}
                                                    handleClick={changeSecondaryBilling}
                                                />
                                            )}
                                            <p>Secondary Billing</p>
                                        </div>
                                    </SimpleTooltip>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="flex-align-start" style={{gap: 16, overflow: 'scroll'}}>
                        {(!info?.activeTab || info?.activeTab === 'Details') && (
                            <div className="flex-align-center" style={{gap: 16}}>
                                {
                                    <>
                                        {claimById?.status === OPEN && (
                                            <SubmittedClaimStatus
                                                info={claimById}
                                                single={claimById?.id}
                                                afterSuccess={handleActionSuccess}
                                            />
                                        )}
                                            {(claimById?.status !== PENDING_CLAIM && claimById?.status !== PAID) && (
                                                <EditWithIcon
                                                    styles={width > 1720 ? {width: 'auto'} : {}}
                                                    innerText={width > 1720 ? 'Resubmission Info' : ''}
                                                    handleClick={() => open(<EditClaim claim={claimById}
                                                                                       afterSuccess={handleActionSuccess}/>)}
                                                />
                                            )}

                                            {claimById?.status !== PAID &&
                                                <RefreshClaim claimById={claimById} afterSuccess={handleActionSuccess}/>
                                            }

                                            {(claimById?.status === OPEN || claimById?.status === APPEAL) &&
                                                canUseIntegrations?.claimStatusCheckEnabled && (
                                                    <div className="check-status-btn-box">
                                                        <EditWithIcon
                                                            styles={{width: width > 1720 ? 150 : 36}}
                                                            icon={Images.verified}
                                                            // innerText={ 'Resubmit'}
                                                            innerText={width > 1720 ? 'Check Status' : ''}
                                                            handleClick={() =>
                                                                open(
                                                                    <CustomDelete
                                                                        info={'Real-Time Claim Status (276/277)'}
                                                                        text={
                                                                            'The system will check the latest status of the selected claim using a real-time 276/277 transaction. The claim status will be updated automatically when the response is received'
                                                                        }
                                                                        handleDel={() =>
                                                                            dispatch(
                                                                                claimActions.checkClaimStatus(
                                                                                    {claimIds: [claimById?.id]},
                                                                                    claimById?.id
                                                                                )
                                                                            )
                                                                        }
                                                                        actionType={CHECK_CLAIM_STATUS}
                                                                        afterSuccess={handleActionSuccess}
                                                                        innerText="Check Status"
                                                                        color={'blue'}
                                                                    />
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                )}

                                            {RolePermission([PermissionList.CLAIMS_UPDATE?.code]) && claimById?.status === PENDING_CLAIM && (
                                                <>
                                                    <button
                                                        // style={{ opacity: (claimById?.incompleteUnitFlag || claimById?.updateFlag) ? 0.5 : 1 }}
                                                        // disabled={claimById?.incompleteUnitFlag || claimById?.updateFlag}
                                                        className={classes.submitClaimBtn}
                                                        type="button"
                                                        onClick={() =>
                                                            open(
                                                                <SelectSubmissionMethod
                                                                    afterSuccess={handleActionSuccess}
                                                                    selectedList={[claimById?.id]}
                                                                />
                                                            )
                                                        }>
                                                        Submit Claim
                                                    </button>
                                                </>
                                            )}

                                            {claimById?.status === OPEN && (
                                                <EditWithIcon
                                                    styles={{width: 121}}
                                                    icon={Images.historyTab}
                                                    // innerText={ 'Resubmit'}
                                                    innerText={
                                                        claimById?.secondaryBilling
                                                            ? claimById?.secondaryBilling?.submitted
                                                                ? 'Resubmit'
                                                                : 'Submit'
                                                            : 'Resubmit'
                                                    }
                                                    handleClick={() =>
                                                        open(
                                                            <ResubmitClaim
                                                                selectedList={claimById?.id}
                                                                afterSuccess={handleActionSuccess}
                                                                submitTitle={`${
                                                                    claimById?.secondaryBilling
                                                                        ? claimById?.secondaryBilling?.submitted
                                                                            ? 'Resubmit'
                                                                            : 'Submit'
                                                                        : 'Resubmit'
                                                                } to Secondary Payer`}
                                                                // secondaryInfo={secondaryInfo?.secondaryBilling ? secondaryInfo : null}
                                                            />
                                                        )
                                                    }
                                                />
                                            )}

                                            {RolePermission([PermissionList.CLAIM_PMT_SEND_APPEAL?.code]) && claimById?.status === APPEAL && (
                                                <RemoveClaim claim={claimById} afterSuccess={handleActionSuccess}/>
                                            )}

                                            {
                                                // RolePermission([PermissionList.UN_SUBMIT_CLAIM_APPT?.code]) &&
                                                [clearinghouseStatusEnums.IN_CH, clearinghouseStatusEnums.CH_REJECTED, clearinghouseStatusEnums.NOT_DELIVERED, clearinghouseStatusEnums.PAYER_PRECHECK].includes(claimById?.clearinghouseStatus) &&
                                                (claimById?.status === OPEN || claimById?.status === APPEAL) && (
                                                    <button
                                                        className="remove-appeal-btn"
                                                        type="button"
                                                        onClick={() =>
                                                            open(
                                                                <CustomDelete
                                                                    info="Cancel Claim?"
                                                                    text="This action will cancel the submitted claim and move all related appts back to the Billable appts section."
                                                                    handleDel={() =>
                                                                        dispatch(
                                                                            claimActions.cancelClaim(
                                                                                {claimIds: [claimById?.id]},
                                                                                claimById?.id
                                                                            )
                                                                        )
                                                                    }
                                                                    actionType={CANCEL_CLAIM}
                                                                    afterSuccess={handleActionSuccess}
                                                                    innerText="Confirm Cancel"
                                                                    body={
                                                                        <div
                                                                            className="deleting-client-info-box"
                                                                            style={{alignItems: 'flex-start'}}>
                                                                            <img
                                                                                style={{marginTop: 4}}
                                                                                src={Images.authFile}
                                                                                alt="icon"
                                                                            />
                                                                            <p style={{fontWeight: 600}}>{claimById?.displayId}</p>
                                                                        </div>
                                                                    }
                                                                />
                                                            )
                                                        }>
                                                        {/*{'Cancel Claim'}*/}
                                                        {'Cancel'}
                                                    </button>
                                                )
                                            }

                                            {RolePermission([PermissionList.CLAIMS_CLOSE?.code]) &&
                                                (claimById?.status === OPEN || claimById?.status === APPEAL) && (
                                                    <button
                                                        className={closeButnStyle}
                                                        type="button"
                                                        onClick={() =>
                                                            open(
                                                                <CustomDelByNote
                                                                    info="Close this claim?"
                                                                    text="Please indicate below the reason for closing the claim."
                                                                    handleDel={(closingComment) => {
                                                                        dispatch(claimActions.closeClaim(claimById?.id, closingComment));
                                                                    }}
                                                                    innerText={'Close'}
                                                                    inputLabel={'Add your comment here ...*'}
                                                                    actionType={CLOS_CLAIM_ACTION_TYPE}
                                                                    afterSuccess={handleActionSuccess}
                                                                />
                                                            )
                                                        }
                                                        disabled={claimIsClosed}>
                                                        {'Close'}
                                                        {/*{'Close Claim'}*/}
                                                    </button>
                                                )}

                                            {claimById?.status === CLOSED_CLAIM && (
                                                <button className={closeButnStyle} type="button" disabled={true}>
                                                    {'Closed'}
                                                </button>
                                            )}

                                            {claimById?.status === PENDING_CLAIM && (
                                                <EditWithIcon
                                                    icon={Images.redTrash}
                                                    handleClick={() =>
                                                        open(
                                                            <CustomDelete
                                                                info="Delete Claim?"
                                                                text="This action will permanently remove the claim and its billing information. It cannot be undone."
                                                                handleDel={() =>
                                                                    dispatch(claimActions.deleteClaim({claimIds: [claimById?.id]}))
                                                                }
                                                                actionType={DELETE_CLAIM}
                                                                afterSuccess={handleRemoveSuccess}
                                                                body={
                                                                    <div
                                                                        className="deleting-client-info-box"
                                                                        style={{alignItems: 'flex-start'}}>
                                                                        <img style={{marginTop: 4}}
                                                                             src={Images.authFile} alt="icon"/>
                                                                        <p style={{fontWeight: 600}}>{claimById?.displayId}</p>
                                                                    </div>
                                                                }
                                                            />
                                                        )
                                                    }
                                                />
                                            )}
                                    </>
                                }
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
